export default __webpack_public_path__ + "static/media/cashback_rewards.cfcfb607.svg";